<template>
  <div class="organization-balance-table-cell">
    <span v-if="billingType === 'BillMeLater'">
      <span class="statement-balance">Statement: {{ statementBalance }}</span>
      <span class="current-balance">Current: {{ currentBalance }}</span>
    </span>
    <span v-else>N/A</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from '@vue';
import * as currencies from '@utils/currencies';

import type { Organization } from '@models';

/**
 * `TableCellOrganizationBalance` component properties.
 */
export interface Props {
  /** ... */
  item: Organization;
}

const props = defineProps<Props>();

const billingType = computed(() => props.item.billingType);

const statementBalance = computed(() =>
  currencies.format({
    amount: props.item.statementBalance ?? 0,
    currency: props.item.seatCost.currency,
    unitType: 'smallest',
  }),
);
const currentBalance = computed(() =>
  currencies.format({
    amount: props.item.currentBalance ?? 0,
    currency: props.item.seatCost.currency,
    unitType: 'smallest',
  }),
);
</script>

<script lang="ts">
declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    TableCellOrganizationBalance: ComponentWithProps<Props>;
  }
}

export default { name: 'TableCellOrganizationBalance' };
</script>

<style lang="scss" scoped>
.organization-balance-table-cell {
  font-size: 12px;
}

.statement-balance {
  color: #372920;
  background-color: #ecb38e;
  display: inline-block;
  padding: 2px 8px;
  text-align: center;
  border-radius: 10px;
}

.current-balance {
  color: #202c37;
  background-color: #85b7e4;
  display: inline-block;
  padding: 2px 8px;
  text-align: center;
  border-radius: 10px;
}
</style>
